<script>
import objectMixin from "@/mixins/objectMixin";
import dateMixin from "@/mixins/dateMixin";
import paymentMixin from "@/mixins/paymentMixin";

export default {
  mixins: [objectMixin, dateMixin, paymentMixin],
  props: {
    payments: {
      type: Array,
      required: true
    }
  },
  filters: {
    methodIcon(payment) {
      return payment.funding_instrument.type === "credit_cards"
        ? "fas fa-credit-card"
        : "fas fa-barcode";
    },
    methodText(payment) {
      return payment.funding_instrument.type === "credit_cards"
        ? "Cartão de crédito"
        : "Boleto";
    }
  }
};
</script>

<template>
  <v-expansion-panels>
    <v-expansion-panel v-for="payment in payments" :key="payment.id">
      <v-expansion-panel-header>
        <v-layout row align-center>
          <v-icon size="50" color="black">{{ payment | methodIcon }}</v-icon>

          <v-flex ml-2 justify-center column>
            <div>
              <b>Forma de pagamento:</b>
              {{ payment | methodText }}
            </div>

            <div class="mt-1">
              <b>Status:</b>
              {{ get(payment, "status") | getPaymentStatus }}
            </div>
          </v-flex>
        </v-layout>
      </v-expansion-panel-header>

      <v-expansion-panel-content>
        <v-divider></v-divider>

        <v-flex mt-5 row wrap justify-space-between no-gutters>
          <div>
            <b>Criado em:</b>
            {{ get(payment, "created_at") | dateAndTime }}
          </div>

          <div>
            <b>WIRECARD ID:</b>
            {{ get(payment, "payment_gateway_id") }}
          </div>

          <template v-if="payment.funding_instrument.type === 'credit_cards'">
            <div>
              <b>Cartão:</b>
              {{ get(payment, "funding_instrument.first6") }}
              ******
              {{ get(payment, "funding_instrument.last4") }}
            </div>
            <div>
              <b>Bandeira:</b>
              {{ get(payment, "funding_instrument.brand") }}
            </div>
          </template>

          <template v-if="payment.funding_instrument.type === 'boletos'">
            <div>
              <b>Código digitável:</b>
              {{ get(payment, "funding_instrument.line_code") }}
            </div>

            <div>
              <b>Vencimento:</b>
              {{ get(payment, "funding_instrument.expiration_date") | getDate }}
            </div>

            <div>
              <a
                :href="get(payment, 'funding_instrument.url_print')"
                target="_blank"
              >
                <b>Imprimir boleto</b>
              </a>
            </div>
          </template>
        </v-flex>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<style scoped>
b {
  font-weight: bold;
}

div {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/OrderPayments.vue